/*
 * サブシステム名：マスタ管理
 * 機能名：発着地単価登録
 */

import DdArrowHeader from '@/components/DdArrowHeader'
import DdSubHeader from '@/components/DdSubHeader'
import DdTextBox from '@/components/DdTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdFooterButton from '@/components/DdFooterButton'
import DdDropDown from '@/components/DdDropDown'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdNumericBox from '@/components/DdNumericBox'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'
import filter from '@/rahmen/utils/filters'
import indexeddb from '@/ddv2.library/indexeddb'
import date from '@/ddv2.library/date'

import { mapGetters } from 'vuex'
import message from '@/ddv2.library/messages'

import header from '@/ddv2.library/header'

export default {
  name: 'MstHacchakuchiTankaEdit',
  mixins: [flowMixin],
  data: () => ({
    id: 0,
    rec: {},
    invalidMessages: {},

    // watch用
    isLoading: false,

    // ヘッダーリスト
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    headersEigyoshoList: header.mstEigyoshoHeaders,
    headersHacchakuchiList: header.mstHacchakuchiHeaders,
    headersHinmeiList: header.mstHinmeiHeaders,
    headersShuhaiChikuList: header.mstShuhaiChikuHeaders,

    currentMstKingaku: {},
    modeOfEdit: 2,
    modeKengen: 2,
    showCopyDialog: false
  }),
  components: {
    DdArrowHeader,
    DdSubHeader,
    DdTextBox,
    DdDateBox,
    DdDropDown,
    DdDefaultButton,
    DdFooterButton,
    DdCodeTextBox,
    DdNumericBox
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      eigyoshoList: 'DDMasters/mstEigyosho',
      kubunList: 'DDMasters/msysKubun',
      shubetsuList: 'DDMasters/mstShubetsu',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      shuhaiChikuList: 'DDMasters/mstShuhaiChiku',
      hinmeiList: 'DDMasters/mstHinmei',
      kihonJohoList: 'DDMasters/mstKihonJoho',
      currentKaishaCode: 'users/currentKaishaCode'
    }),
    // 単価表区分リスト
    filteredTankahyoKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN026')
    },
    // 単価表詳細区分リスト
    filteredTankahyoDetailKbn () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'KBN027')
    },
    // 取引先リスト
    filteredTorihikisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    },
    // 営業所リスト
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.eigyoshoCd > elem2.eigyoshoCd) { return 1 }
        if (elem1.eigyoshoCd === elem2.eigyoshoCd) { return 0 }
        return -1
      })
    },
    // 品名リスト
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      const self = this
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        // 取引先コードがNULL(空)、または選択中の取引先が対象
        return (elem.torihikisakiCd === null || elem.torihikisakiCd === '' || self.rec.torihikisakiCd === elem.torihikisakiCd) && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hinmeiCd > elem2.hinmeiCd) { return 1 }
        if (elem1.hinmeiCd === elem2.hinmeiCd) { return 0 }
        return -1
      })
    },
    // 品種種別リスト
    filteredHinsyuShubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    // 荷姿種別リスト
    filteredNisugataShubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT019')
    },
    // 運賃車種種別リスト
    filteredUnchinShashuShubetsu () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 運賃計算方法区分フィルター
    filteredUnchinKeisanKbnList () {
      return this.kubunListFilterForDropDownItem(this.kubunList, 'SFF055')
    },
    // 発着地リスト
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.hacchakuchiCd > elem2.hacchakuchiCd) { return 1 }
        if (elem1.hacchakuchiCd === elem2.hacchakuchiCd) { return 0 }
        return -1
      })
    },
    // 地区リスト
    filteredShuhaiChikuList () {
      const target = filter.dateFormatter(new Date())
      return this.shuhaiChikuList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    /*
    // マスタ金額からFlgを取得するための関数
    currentMstKingaku () {
      console.log('★カレントマスタ金額動作★')
      if (this.rec.torihikisakiCd === undefined || this.rec.torihikisakiCd === null) {
        // 取引先が設定されていない場合
        // 基本情報マスタから金額マスタIDを取得
        const mt = this.kihonJohoList.find((tr) => {
          return tr
        })
        if (mt === undefined || mt === null) { return {} }
        // 対象となる金額マスタを取得
        const mk = this.kingakuList.find((k) => {
          return k.id === mt.mstKingakuId
        })
        if (mk === undefined || mk === null) { return {} }
        return mk
      } else {
        // 取引先が設定されている場合
        // 取引先CDで取引先を取得
        const mtr = this.torihikisakiList.find((tr) => {
          return tr.torihikisakiCd === this.rec.torihikisakiCd
        })
        if (mtr === undefined || mtr === null) { return {} }
        // 取引先IDで得意先を取得
        let mt = this.tokuisakiList.find((t) => {
          return t.mstTorihikisakiId === mtr.id
        })
        // 得意先マスタの金額マスタIDが設定されていない場合、基本情報マスタから金額マスタIDを取得
        if (mt.mstKingakuId === undefined || mt.mstKingakuId === null) {
          mt = this.kihonJohoList.find((tr) => {
            return tr
          })
        }
        // 対象となる金額マスタを取得
        const mk = this.kingakuList.find((k) => {
          return k.id === mt.mstKingakuId
        })
        if (mk === undefined || mk === null) { return {} }
        return mk
      }
    },
    */
    isRirekiFukusyaDisplay () {
      if (this.modeOfEdit === 2 && (this.modeKengen === 1 || this.modeKengen === 2)) {
        console.log('★true')
        return true
      }
      console.log('★false')
      return false
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      // if (this.modeKengen === 2 && (this.modeOfEdit === 0 || this.modeOfEdit === 2)) {
      if (this.modeKengen === 2 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1) {
        return true
      }
      return false
    },
    isShoukaiMode () {
      return this.modeOfEdit === 1
    }

  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  watch: {
    'rec.torihikisakiCd': function () {
      // 取引先が変更された時、品名が選択可能な対象ではない場合はNULLに変更
      if (!this.isLoading && this.rec.hinmeiCd && this.filteredHinmeiList.every((elem) => elem.hinmeiCd !== this.rec.hinmeiCd)) {
        this.rec.hinmeiCd = null
      }
      if (this.rec.torihikisakiCd) {
        var baseYmd = date.getCurrentDate()
        var torihikisakiId = indexeddb.getRecordByCd(this.currentKaishaCode, this.torihikisakiList, 'torihikisakiCd', this.rec.torihikisakiCd, baseYmd).id
        this.HttpClient
          .get(`/api/v1/MstKingaku/FindByType?id=${torihikisakiId}&kinKbn=${1}`)
          .then((data) => {
            this.currentMstKingaku = data.payload
            this.kingakuReferenceFlg()
          })
      } else {
        this.HttpClient
          .get(`/api/v1/MstKingaku/FindByType?id=${0}&kinKbn=${0}`)
          .then((data) => {
            this.currentMstKingaku = data.payload
            this.kingakuReferenceFlg()
          })
      }
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const opt = {
        nextCallback: next
      }
      this.preventTransition(opt)
    },
    fetchData: function () {
      const self = this
      console.log('fetchData')
      return new Promise((resolve) => {
        console.log(this.id)
        this.HttpClient
          .get(`/api/v1/MstHacchakuchiTanka/find?id=${self.id}`)
          .then((data) => {
            if (data.payload) {
              console.log('★fetchData', data.payload)

              self.isLoading = true

              self.rec = data.payload
              delete self.rec.tekiyoStartYmd
              delete self.rec.tekiyoEndYmd
              // 単価表種類区分
              if (!self.rec.tankahyoKbn) {
                self.rec.tankahyoKbn = ''
              }
              // 単価表種類詳細区分
              if (!self.rec.tankahyoDetailKbn) {
                self.rec.tankahyoDetailKbn = ''
              }
              // 品種種別
              if (!self.rec.hinshuSbt) {
                self.rec.hinshuSbt = ''
              }
              // 荷姿種別
              if (!self.rec.nisugataSbt) {
                self.rec.nisugataSbt = ''
              }
              // 運賃車種種別
              if (!self.rec.unchinShashuSbt) {
                self.rec.unchinShashuSbt = ''
              }

              self.rec.tekiyoStartYmdString = self.rec.tekiyoStartYmdString ? self.rec.tekiyoStartYmdString : ''
              self.rec.tekiyoEndYmdString = self.rec.tekiyoEndYmdString ? self.rec.tekiyoEndYmdString : ''

              this.$nextTick(() => { self.isLoading = false })
            }
            resolve()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msttorihikisaki', 'msteigyosho', 'mstshubetsu', 'msyskubun', 'msthacchakuchi', 'mstshuhaichiku', 'msthinmei', 'mstkihonjoho'],
        initializeInputPromise: () => {
          return new Promise((resolve) => {
            self.rec = {
              tankahyoCd: null,
              tankahyoKbn: null,
              tankahyoDetailKbn: null,
              torihikisakiCd: null,
              eigyoshoCd: null,
              hatsuchiCd: null,
              hatsuChikuCd: null,
              chakuchiCd: null,
              chakuChikuCd: null,
              kyoriFrom: null,
              kyoriTo: null,
              suryoFrom: null,
              suryoTo: null,
              juryoFrom: null,
              juryoTo: null,
              sharyoSizeFrom: null,
              sharyoSizeTo: null,
              hinmeiCd: null,
              hinshuSbt: null,
              nisugataSbt: null,
              unchinShashuSbt: null,
              tanka: null,
              kihonUnchin: null,
              jikanWarimashiKingaku: null,
              kyoriWarimashiKingaku: null,
              keisuWarimashiKingaku: null,
              nenryoWarimashiKingaku: null,
              hiwayPrice: null,
              userKingakuKazei1: null,
              userKingakuKazei2: null,
              userKingakuKazei3: null,
              userKingakuKazei4: null,
              userKingakuKazei5: null,
              userKingakuKazei6: null,
              userKingakuKazei7: null,
              userKingakuKazei8: null,
              userKingakuKazei9: null,
              userKingakuKazei10: null,
              userKingakuHikazei1: null,
              userKingakuHikazei2: null,
              userKingakuHikazei3: null,
              userKingakuHikazei4: null,
              userKingakuHikazei5: null,
              userKingakuHikazei6: null,
              userKingakuHikazei7: null,
              userKingakuHikazei8: null,
              userKingakuHikazei9: null,
              userKingakuHikazei10: null,
              userKingakuUchizei1: null,
              userKingakuUchizei2: null,
              userKingakuUchizei3: null,
              userKingakuUchizei4: null,
              userKingakuUchizei5: null,
              userKingakuUchizei6: null,
              userKingakuUchizei7: null,
              userKingakuUchizei8: null,
              userKingakuUchizei9: null,
              userKingakuUchizei10: null,
              tekiyoStartYmdString: '2000/01/01',
              tekiyoEndYmdString: '2100/01/01',
              hyojiOrder: 9999
            }
            console.log('★Initialize', self.rec)
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise((resolve) => {
            console.log('★savedInputRestorePromise', c)
            resolve()
          })
        },
        existsIdMethod: () => {
          return this.id !== 0
        },
        requestApiPromise: this.fetchData,
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              this.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              this.modeKengen = 1
            } else {
              // フルアクセス
              this.modeKengen = 2
            }
            // thisId == 0 then 新規モード
            if (this.id === 0) {
              this.modeOfEdit = 0 // 新規モード
            } else if (this.modeKengen === 0) {
              this.modeOfEdit = 1 // 照会モード
            } else {
              this.modeOfEdit = 2 // 更新モード
            }
            console.log('modeOfEdit', this.modeOfEdit)
            console.log('modeKengen', this.modeKengen)
            resolve()
          })
        },
        settingItemMethod: (kengen) => {
          console.log('settingItemMethod', kengen)
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, opt)
      this.initializeForRegister(opt)
    },
    onRirekiFukushaButtonClick: function (e) {
      console.log('onRirekiFukushaButtonClick', e)
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = data().rec
            self.rec.id = self.id
            resolve()
          })
        }
      }

      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.delete(`/api/v1/MstHacchakuchiTanka/Delete?id=${self.id}&tm=${self.rec.timestamp}`, self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }
      this.delete(opt)
    },
    onCopyButtonClick: function (e) {
      const self = this
      const opt = {
        setIdMethod: () => {
          self.id = 0
          self.rec.id = 0
          self.modeOfEdit = 0
        }
      }
      this.copyInputs(opt)
    },
    onSaveButtonClick: function (e) {
      const self = this
      console.log('★保存ボタンクリック')
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.id = data.payload.id
            console.log('★registerResponsePromise', self.id)
            resolve()
          })
        },
        judgeKeyChangedMethod: (data) => {
          return data.rec.tankahyoCd !== this.rec.tankahyoCd
        },
        getIdMethod: () => {
          console.log('getIdMethod', self.id)
          return self.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            console.log('continuousInputInitializePromise', id)
            this.id = id
            this.transition(1, { id: id }, this.initialize)
            resolve()
          })
        },
        getTransitionBackParams: function () {
          console.log('getTransitionBackParams', self.id)
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          console.log('isUpdateModeMethod', self.id)
          return self.id !== 0
        },
        getSavedInputMethod: function () {
          console.log('★getSavedInputMethod★')
          return {}
        }
      }

      this.register(opt)
    },
    registerPromise: function () {
      let f

      if (this.id === 0) {
        console.log('★登録処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.post('/api/v1/MstHacchakuchiTanka/Create', this.rec)
      } else {
        console.log('★更新処理')
        console.log('★rec', this.rec)
        f = this.HttpClient.put(`/api/v1/MstHacchakuchiTanka/Update?id=${this.id}`, this.rec)
      }
      return f
    },
    registerValidate: function () {
      console.log('★validate start', this.cloneData)
      console.log('◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆◆', this.$refs)
      const msg = validators.compareDate(this.rec.tekiyoStartYmdString, this.rec.tekiyoEndYmdString)
      if (msg !== undefined) {
        this.$refs.tekiyoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        this.$refs.tekiyoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg)
        return false
      }
      console.log('★validate OK')
      return true
    },
    deleteValidate: function () {
      console.log('delete=cloneData', this.cloneData)
      if (this.rec.tankahyoCd !== this.cloneData.rec.tankahyoCd) {
        this.$refs.tankahyoCd[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121', ['単価表コード']))
        this.setInvalidSummaryMessage('COME0015')
        return false
      }
      console.log('validate OK')
      return true
    },
    kingakuReferenceFlg () {
      // カレントマスタ金額テーブルの各Flgを参照して、非表示になるときNullを設定する
      const kingakuFlg = this.currentMstKingaku

      // 固定金額６種類
      if (!kingakuFlg.kihonUnchinShiyoFlg) {
        this.rec.kihonUnchin = null
      }
      if (!kingakuFlg.jikanWarimashiKingakuShiyoFlg) {
        this.rec.jikanWarimashiKingaku = null
      }
      if (!kingakuFlg.kyoriWarimashiKingakuShiyoFlg) {
        this.rec.kyoriWarimashiKingaku = null
      }
      if (!kingakuFlg.keisuWarimashiKingakuShiyoFlg) {
        this.rec.keisuWarimashiKingaku = null
      }
      if (!kingakuFlg.nenryoWarimashiKingakuShiyoFlg) {
        this.rec.nenryoWarimashiKingaku = null
      }
      if (!kingakuFlg.hiwayPriceShiyoFlg) {
        this.rec.hiwayPrice = null
      }
      // ユーザー金額（課税）
      if (!kingakuFlg.userKingakuKazei1ShiyoFlg) {
        this.rec.userKingakuKazei1 = null
      }
      if (!kingakuFlg.userKingakuKazei2ShiyoFlg) {
        this.rec.userKingakuKazei2 = null
      }
      if (!kingakuFlg.userKingakuKazei3ShiyoFlg) {
        this.rec.userKingakuKazei3 = null
      }
      if (!kingakuFlg.userKingakuKazei4ShiyoFlg) {
        this.rec.userKingakuKazei4 = null
      }
      if (!kingakuFlg.userKingakuKazei5ShiyoFlg) {
        this.rec.userKingakuKazei5 = null
      }
      if (!kingakuFlg.userKingakuKazei6ShiyoFlg) {
        this.rec.userKingakuKazei6 = null
      }
      if (!kingakuFlg.userKingakuKazei7ShiyoFlg) {
        this.rec.userKingakuKazei7 = null
      }
      if (!kingakuFlg.userKingakuKazei8ShiyoFlg) {
        this.rec.userKingakuKazei8 = null
      }
      if (!kingakuFlg.userKingakuKazei9ShiyoFlg) {
        this.rec.userKingakuKazei9 = null
      }
      if (!kingakuFlg.userKingakuKazei10ShiyoFlg) {
        this.rec.userKingakuKazei10 = null
      }
      // ユーザー金額（非課税）
      if (!kingakuFlg.userKingakuHikazei1ShiyoFlg) {
        this.rec.userKingakuHikazei1 = null
      }
      if (!kingakuFlg.userKingakuHikazei2ShiyoFlg) {
        this.rec.userKingakuHikazei2 = null
      }
      if (!kingakuFlg.userKingakuHikazei3ShiyoFlg) {
        this.rec.userKingakuHikazei3 = null
      }
      if (!kingakuFlg.userKingakuHikazei4ShiyoFlg) {
        this.rec.userKingakuHikazei4 = null
      }
      if (!kingakuFlg.userKingakuHikazei5ShiyoFlg) {
        this.rec.userKingakuHikazei5 = null
      }
      if (!kingakuFlg.userKingakuHikazei6ShiyoFlg) {
        this.rec.userKingakuHikazei6 = null
      }
      if (!kingakuFlg.userKingakuHikazei7ShiyoFlg) {
        this.rec.userKingakuHikazei7 = null
      }
      if (!kingakuFlg.userKingakuHikazei8ShiyoFlg) {
        this.rec.userKingakuHikazei8 = null
      }
      if (!kingakuFlg.userKingakuHikazei9ShiyoFlg) {
        this.rec.userKingakuHikazei9 = null
      }
      if (!kingakuFlg.userKingakuHikazei10ShiyoFlg) {
        this.rec.userKingakuHikazei10 = null
      }
      // ユーザー金額（内税）
      if (!kingakuFlg.userKingakuUchizei1ShiyoFlg) {
        this.rec.userKingakuUchizei1 = null
      }
      if (!kingakuFlg.userKingakuUchizei2ShiyoFlg) {
        this.rec.userKingakuUchizei2 = null
      }
      if (!kingakuFlg.userKingakuUchizei3ShiyoFlg) {
        this.rec.userKingakuUchizei3 = null
      }
      if (!kingakuFlg.userKingakuUchizei4ShiyoFlg) {
        this.rec.userKingakuUchizei4 = null
      }
      if (!kingakuFlg.userKingakuUchizei5ShiyoFlg) {
        this.rec.userKingakuUchizei5 = null
      }
      if (!kingakuFlg.userKingakuUchizei6ShiyoFlg) {
        this.rec.userKingakuUchizei6 = null
      }
      if (!kingakuFlg.userKingakuUchizei7ShiyoFlg) {
        this.rec.userKingakuUchizei7 = null
      }
      if (!kingakuFlg.userKingakuUchizei8ShiyoFlg) {
        this.rec.userKingakuUchizei8 = null
      }
      if (!kingakuFlg.userKingakuUchizei9ShiyoFlg) {
        this.rec.userKingakuUchizei9 = null
      }
      if (!kingakuFlg.userKingakuUchizei10ShiyoFlg) {
        this.rec.userKingakuUchizei10 = null
      }
    }
  }
}
